import { Capacitor } from "@capacitor/core";
import { Money } from "ts-money";

import { currencyService } from "./CurrencyService";

export function formatCurrency(value: number, maximumFractionDigits?: number) {
  const currency = currencyService.getCurrency();
  const amount = Money.fromInteger(value, currency).toDecimal();

  // Auto-detect if we should hide cents when they are 0
  const hasCents = value % 100 !== 0;
  const fractionDigits =
    maximumFractionDigits !== undefined
      ? maximumFractionDigits
      : hasCents
      ? 2
      : 0;

  if (Capacitor.isNativePlatform()) {
    // Custom formatting for Capacitor because Intl.NumberFormat throws a
    // RangeError when maximumFractionDigits is 0
    const formattedValue = amount
      .toFixed(fractionDigits)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$${formattedValue}`;
  } else {
    // Use Intl.NumberFormat for web
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency.code,
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
    }).format(amount);
  }
}

/**
 * Formats a backend price value (in cents) to a price string without currency
 * symbol (in dollars).
 */
export const formatNoCurrency = (value: number, maximumFractionDigits = 2) =>
  (value / 100).toFixed(maximumFractionDigits);

/**
 * Parse a formatted price string to a backend price value (in cents). Accepts
 * string both with and without currency symbol.
 */
export const parsePriceString = (value: string) => {
  const parsedValue = Number(value.replace(/[$,]/g, ""));
  return Number.isFinite(parsedValue) ? Math.round(parsedValue * 100) : null;
};
